var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"id":_vm.domId,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),(_vm.label)?_c('label',{attrs:{"for":_vm.domId}},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }